import { render, staticRenderFns } from "./ChatBotLayout.vue?vue&type=template&id=7a7a0bf9&scoped=true&"
import script from "./ChatBotLayout.vue?vue&type=script&lang=js&"
export * from "./ChatBotLayout.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotLayout.vue?vue&type=style&index=0&id=7a7a0bf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7a0bf9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7a0bf9')) {
      api.createRecord('7a7a0bf9', component.options)
    } else {
      api.reload('7a7a0bf9', component.options)
    }
    module.hot.accept("./ChatBotLayout.vue?vue&type=template&id=7a7a0bf9&scoped=true&", function () {
      api.rerender('7a7a0bf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatBot/ChatBotLayout.vue"
export default component.exports